// extracted by mini-css-extract-plugin
module.exports = {"nodataContainer":"nodata_nodataContainer__uyprW","nodataText":"nodata_nodataText__tgz0t"};